import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Loader,
  Modal,
  Paragraph,
  Spacing,
  Title,
} from "@sicredi/react";
import { CardResume } from "#/components/CardResume";
import styles from "./styles.module.scss";
import { PAGE } from "#/constants";
import Accordion from "#/components/Accordion";
import { useNavigate } from "react-router-dom";
import { ContextAPI } from "#/contextProver/ContextProver";
import {
  formatRegexCep,
  formatRegexCpfCnpj,
  formatValueMoney,
  getBensGruposByIdSimulacao,
  getPercentualTaxaAdm,
  getValorDecodeBase64,
  handleEmitirRegulamento,
  toastErrorMenssage,
} from "#/contextProver/ContextProverServices";
import { getVendasCadastroPropostaVenda } from "#/api/getVendasCadastroPropostaVenda";
import dayjs from "dayjs";
import { getVendasListaProposta } from "#/api/getVendasListaProposta";

export const Resume: React.FC = () => {
  const {
    vendasResumo,
    agencyAccountCommissioned,
    codigoComissionado,
    idSimulacao,
    setIdDocumento,
    idComercial,
    products,
    vendasPlanosCobranca,
    setVendasListaProposta,
    documento,
    isMobile,
    isLoading,
    setIsLoading,
    bens,
  } = useContext(ContextAPI);
  const navigate = useNavigate();

  const currentProduct = products.find(
    (item) => item.idComercial === idComercial
  );

  const [isOpenModal, setIsOpenModal] = useState(false);

  const resumo = vendasResumo.data ? vendasResumo.data : null;
  const vendasCobranca = vendasPlanosCobranca.data
    ? vendasPlanosCobranca.data[0]
    : null;
  const isCPF = documento ? documento.length <= 11 : null;
  const vencimentoBoleto = String(dayjs().add(2, "day"));

  const bensGruposByIdSimulacao = getBensGruposByIdSimulacao({
    bensGrupos: bens?.data,
    idSimulacao,
  });

  const handleModalButtonConcluir = async () => {
    try {
      setIsLoading(true);
      if (resumo) {
        const vendasCadastroPropostaVenda =
          await getVendasCadastroPropostaVenda({
            codigoComissionado,
            idSimulacao,
            name: agencyAccountCommissioned?.nome,
            documento,
            phone: resumo.telefone,
            email: resumo.email,
            agencia: resumo.numeroAgencia,
            account: resumo.numeroContaCorrente,
          });
        setIdDocumento(vendasCadastroPropostaVenda.data.documentId);
      }

      const vendasListaProposta = await getVendasListaProposta({
        codigoComissionado,
        documento,
      });
      setVendasListaProposta(vendasListaProposta);

      setIsLoading(false);
      setIsOpenModal(false);
      navigate(PAGE.TRACKING);
    } catch {
      setIsLoading(false);
      setIsOpenModal(false);
      toastErrorMenssage();
    }
  };

  useEffect(() => {
    if (bens?.data.length === 0) {
      navigate(PAGE.ROOT);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.container}>
      <Loader show={isLoading} fullScreen />
      <Title as="h1" weight="semi-bold" className={styles.title}>
        Confirme os dados da proposta
      </Title>
      <Paragraph size="small" weight="normal" className={styles.paragraph}>
        Condições sujeitas à análise e aprovação do crédito.
      </Paragraph>

      <Spacing appearance="small" />

      <div className={styles.grid_container}>
        {resumo && (
          <>
            {currentProduct && (
              <CardResume
                title={currentProduct.nomeProduto}
                description={resumo.nomeBem}
              />
            )}
            <CardResume
              title="Parcelas"
              description={formatValueMoney(resumo.valorPrimeirasParcelas)}
            />
            <CardResume
              title="Composição da parcela"
              description={`Taxa de adm ${
                resumo.percentualTaxaAdm
              }% (${getPercentualTaxaAdm(
                resumo.percentualTaxaAdm,
                resumo.prazoRestante
              )}% am)`}
            />
          </>
        )}
        {vendasCobranca && resumo && (
          <CardResume
            title="Fundo reserva"
            description={`${String(
              vendasCobranca?.percentualFundoReserva
            )}% (${Number.parseFloat(
              String(
                Number(
                  vendasCobranca.percentualFundoReserva / resumo.prazoRestante
                )
              )
            ).toFixed(2)}% am)`}
          />
        )}
        <CardResume title="Plano" description="Mensal" />
      </div>

      <Accordion
        key={"1"}
        title={"Dados pessoais"}
        content={
          <div>
            <CardResume
              title="Tipo de pessoa"
              description={isCPF ? "PF" : "PJ"}
            />

            <CardResume
              title={isCPF ? "Nome completo" : "Razão Social"}
              description={agencyAccountCommissioned.nome}
            />

            <CardResume
              title={isCPF ? "CPF" : "CNPJ"}
              description={formatRegexCpfCnpj(documento)}
            />
          </div>
        }
        isShowLineBottom={false}
      />

      <Accordion
        key={"2"}
        title={"Dados para contato"}
        content={
          <div>
            {resumo && (
              <>
                <CardResume
                  title="Endereço"
                  description={`${resumo.endereco},${" "}
                  ${resumo.numeroEndereco},${" "}
                  ${resumo.bairro},${" "}
                  ${resumo.cidade}${" - "}
                  ${resumo.estado}${" - "}
                  ${formatRegexCep(resumo.cep)}`}
                />
                <CardResume
                  title="E-mail cadastrado"
                  description={resumo.email}
                />
                <CardResume
                  title="Telefone com DDD"
                  description={resumo.telefone.replace(/[()]/g, "")}
                />
              </>
            )}
          </div>
        }
        isShowLineBottom={false}
      />

      <Accordion
        key={"3"}
        title={"Informações sobre o grupo"}
        content={
          <div>
            {resumo && (
              <>
                <CardResume
                  title="Prazo total do grupo"
                  description={`${resumo.numeroParcela} meses`}
                />
                <CardResume
                  title="Vencimento do boleto de adesão"
                  description={dayjs(vencimentoBoleto).format("DD/MM/YYYY")}
                />
                <CardResume
                  title="Dia do vencimento do grupo"
                  description={resumo.dataVencimentoProposta}
                />
              </>
            )}
            <CardResume
              title="Número máximo de participantes"
              description={String(
                bensGruposByIdSimulacao?.quantidadeParticipante
              )}
            />
          </div>
        }
        textButton="Confira o regulamento"
        isShowLineBottom={false}
        onClickButton={async () =>
          await handleEmitirRegulamento({
            idProduto: currentProduct?.idProduto as number,
            codigoComissionado,
            setIsLoading,
          })
        }
      />

      <Accordion
        key={"4"}
        title={"Dados do pagamento e conta"}
        content={
          <div>
            <CardResume
              title="Coop"
              description={getValorDecodeBase64(
                agencyAccountCommissioned?.agencia
              )}
            />
            <CardResume
              title="Ag"
              description={agencyAccountCommissioned?.posto}
            />
            {resumo && (
              <>
                <CardResume
                  title="Conta"
                  description={resumo.numeroContaCorrente}
                />
                <CardResume
                  title="Tipo de pagamento"
                  description="Débito em Conta"
                />
                <CardResume
                  title="Dia do vencimento do grupo"
                  description={resumo.dataVencimentoProposta}
                />
              </>
            )}
          </div>
        }
        isShowLineBottom={false}
      />

      <Accordion
        key={"5"}
        title={"Dados para devolução de valores"}
        content={
          <div>
            <CardResume
              title="Coop"
              description={getValorDecodeBase64(
                agencyAccountCommissioned?.agencia
              )}
            />
            <CardResume
              title="Ag"
              description={agencyAccountCommissioned?.posto}
            />
            {resumo && (
              <CardResume
                title="Conta"
                description={resumo.numeroContaCorrente}
              />
            )}
            <CardResume
              title="Tipo de pagamento"
              description="Crédito em Conta"
            />
          </div>
        }
        isShowLineBottom={false}
      />

      <Spacing appearance="small" />

      <div className={styles.container_button}>
        <Button
          appearance="secondary"
          size={isMobile ? undefined : "large"}
          onClick={() => navigate(PAGE.ESCOLHA_DO_PLANO)}
          className={styles.button}
        >
          Voltar
        </Button>

        <Button
          appearance="primary"
          size={isMobile ? undefined : "large"}
          onClick={() => setIsOpenModal(true)}
          className={styles.button}
        >
          Confirmar
        </Button>
      </div>
      <Modal
        title="Conferiu todos os dados?"
        onClose={() => setIsOpenModal(false)}
        show={isOpenModal}
        primaryButton={{
          children: "Concluir",
          onClick: async () => await handleModalButtonConcluir(),
        }}
        secondaryButton={{
          children: "Voltar",
          onClick: () => setIsOpenModal(false),
        }}
      >
        Ao clicar em "Concluir” será necessário efetuar o pagamento do boleto de
        adesão.
      </Modal>
    </div>
  );
};
